import { useEffect } from 'react';

export const LESSON_PROGRESS_UPDATE_EVENT_NAME = 'lessonProgress:update';

/**
 * React hook that for stateless components to change the percentage of the progress bar.
 * @param {Number} percentage
 * @example
 *   const MyComponent = props => {
 *     usePercentage(100);
 *     return <div>Component body</div>;
 *   };
 */
export function usePercentage(percentage) {
  useEffect(
    () => pubsub.publish(LESSON_PROGRESS_UPDATE_EVENT_NAME, percentage),
    [percentage],
  );
}

/**
 * React component that manually changes the percentage of the progress bar when mounted.
 * @param {Number} percentage
 * @example
 *   <LessonProgressProvider percentage={100} />
 */
const LessonProgressProvider = ({ percentage }) => {
  usePercentage(percentage);
  return null;
};

export default LessonProgressProvider;
